import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, KeyRound, CheckCircle2 } from "lucide-react";
import { formatApiErrorDetail } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { LOGO } from "@/lib/brand";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { email, birth_date: birthDate, new_password: password });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A1030] p-6">
      <div className="w-full max-w-sm" data-testid="reset-form">
        <div className="flex flex-col items-center text-center mb-8">
          <img src={LOGO} alt="In His Image Radio" className="w-20 h-20 rounded-3xl object-cover mb-4" />
          <h1 className="font-display font-black text-3xl tracking-tighter flex items-center gap-2"><KeyRound className="w-6 h-6 text-[#E6B34A]" /> Reset password</h1>
          <p className="text-zinc-400 mt-2">Verify with your email and birth date to set a new password.</p>
        </div>

        {done ? (
          <div className="text-center rounded-2xl border border-white/5 bg-[#141C42] p-8" data-testid="reset-success">
            <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto mb-4" />
            <p className="text-zinc-300">Your password has been updated.</p>
            <button onClick={() => navigate("/login")} className="mt-6 w-full h-12 rounded-xl bg-[#E6B34A] text-[#0A1030] font-bold hover:bg-[#CF9A34] transition-colors">Back to sign in</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            {error && <div className="text-sm text-[#FF3B30] bg-[#FF3B30]/10 border border-[#FF3B30]/20 rounded-xl px-4 py-3" data-testid="reset-error">{error}</div>}
            <div><label className="overline text-zinc-400">Email</label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="reset-email" className="mt-1.5 bg-[#1E2A5A] border-white/10 focus-visible:ring-[#E6B34A] h-12" /></div>
            <div><label className="overline text-zinc-400">Birth date</label><Input type="date" value={birthDate} onChange={(e) => setBirthDate(e.target.value)} required data-testid="reset-birthdate" className="mt-1.5 bg-[#1E2A5A] border-white/10 focus-visible:ring-[#E6B34A] h-12" /></div>
            <div><label className="overline text-zinc-400">New password</label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="reset-password" className="mt-1.5 bg-[#1E2A5A] border-white/10 focus-visible:ring-[#E6B34A] h-12" /></div>
            <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full h-12 rounded-xl bg-[#E6B34A] text-[#0A1030] font-bold hover:bg-[#CF9A34] transition-colors disabled:opacity-60 flex items-center justify-center">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Reset password"}
            </button>
            <p className="text-sm text-zinc-400 text-center">Remembered it? <Link to="/login" className="text-[#E6B34A] font-semibold">Sign in</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
